function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 18,
  cy: 18,
  r: 17,
  stroke: "#9F9A98",
  strokeWidth: 2
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.3881 23.0001H13.0393V15.1431H15.3881V23.0001ZM24.0003 23.0001H21.6515V18.8029C21.6515 17.7092 21.2632 17.1647 20.4936 17.1647C19.8837 17.1647 19.4969 17.4695 19.3027 18.08V23.0001H16.9539C16.9539 23.0001 16.9853 15.9288 16.9539 15.1431H18.8079L18.9512 16.7145H18.9997C19.4812 15.9288 20.2509 15.3961 21.3062 15.3961C22.1087 15.3961 22.7578 15.62 23.2534 16.1825C23.7521 16.7459 24.0003 17.5017 24.0003 18.5632V23.0001Z",
  fill: "#989C9F"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.2135 14.3571C14.8838 14.3571 15.4271 13.8294 15.4271 13.1785C15.4271 12.5277 14.8838 12 14.2135 12C13.5433 12 13 12.5277 13 13.1785C13 13.8294 13.5433 14.3571 14.2135 14.3571Z",
  fill: "#989C9F"
});

var SvgSocialIn = function SvgSocialIn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSocialIn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/social-in.9ad3ffd2.svg";
export { ForwardRef as ReactComponent };